import { configureAdminDataSource, getAdminDataSourceInfo } from "data/admin/dataSource";
import { createBrowserAdminAdapter } from "data/admin/browserAdapter";
import { createFirebaseAdminAdapter } from "data/admin/firebaseAdminAdapter";
import { isFirebaseConfigured } from "data/firebase";

let bootstrapPromise = null;
let bootstrapState = {
  ready: false,
  kind: "pending",
  error: null,
};

export function getAdminBootstrapState() {
  return { ...bootstrapState };
}

/**
 * Firebase varsa Firestore adapter, yoksa localStorage.
 * Uygulama açılışında bir kez çağrılır.
 */
export function bootstrapAdminDataSource() {
  if (bootstrapPromise) return bootstrapPromise;

  bootstrapPromise = (async () => {
    if (!isFirebaseConfigured) {
      configureAdminDataSource(createBrowserAdminAdapter());
      bootstrapState = { ready: true, kind: "browser-storage", error: null };
      return bootstrapState;
    }

    try {
      const adapter = createFirebaseAdminAdapter();
      configureAdminDataSource(adapter);
      await adapter.hydrate({ seedIfEmpty: true });
      bootstrapState = {
        ready: true,
        kind: "firebase",
        error: null,
        info: getAdminDataSourceInfo(),
      };
      return bootstrapState;
    } catch (error) {
      console.warn("[bootstrapAdminData] Firebase hydrate başarısız, localStorage'a düşülüyor:", error);
      configureAdminDataSource(createBrowserAdminAdapter());
      bootstrapState = {
        ready: true,
        kind: "browser-storage",
        error: error?.message || String(error),
      };
      return bootstrapState;
    }
  })();

  return bootstrapPromise;
}
